import styled from 'styled-components'
import {RegularBlock, media} from '@modifi/ui'

export const Wrapper = styled.div`
  position: relative;
  margin: 0;
  ${media.xs`
    margin: 20px 0 0;
  `}
`

export const ProgressBarLabel = styled(RegularBlock)<{$bold?: boolean; $departure?: boolean}>`
  font-size: 14px;
  font-weight: ${({$bold}): string => ($bold ? '600' : 'normal')};
  text-align: ${({$departure}): string => ($departure ? 'start' : 'end')};
`
